import SoTextField from "@/components/formControls/SoTextField.vue"
import SoTextArea from "@/components/formControls/SoTextarea.vue"
import SoAlert from "@/components/SoAlert.vue"
import SoDatePicker from "@/components/formControls/SoDatePicker.vue"
import SoRadioGroup from "@/components/formControls/SoRadioGroup.vue"
import SoCheckbox from "@/components/formControls/SoCheckbox.vue"
import CotContactsInput from "@/views/customer/changeOfTenancy/components/CotContactsInput.vue"
import CotSubmitReadings from "@/views/customer/changeOfTenancy/components/CotSubmitReadings.vue"
import CotSummary from "@/views/customer/changeOfTenancy/components/CotSummary.vue"
import { mapKeysToValues } from "@/flows/utils"
import SubmitReadings from "@/views/customer/meterpoints/components/SubmitReadings"
import CotSupplyHistory from "@/views/customer/changeOfTenancy/components/CotSupplyHistory.vue"
import CotTariffInfo from "@/views/customer/changeOfTenancy/components/CotTariffInfo.vue"
import CotTariffInput from "@/views/customer/changeOfTenancy/components/CotTariffInput.vue"
import CotDirectDebitInput from "@/views/customer/changeOfTenancy/components/CotDirectDebitInput.vue"
import CotForwardAddressInput from "@/views/customer/changeOfTenancy/components/CotForwardAddressInput.vue"
import CotCompleted from "@/views/customer/changeOfTenancy/components/CotCompleted.vue"
import FetchSmartReadWidgets from "@/components/meterpoints/FetchSmartReadWidgets.vue"
import ImbpJobType from "@/views/customer/imbp/components/ImbpJobType.vue"
import ImbpChooseAppointment from "@/views/customer/imbp/components/ImbpChooseAppointment.vue"
import ImbpExtraInformation from "@/views/customer/imbp/components/ImbpExtraInformation.vue"
import ImbpAppointmentSummary from "@/views/customer/imbp/components/ImbpAppointmentSummary.vue"
import ImbpBookings from "@/views/customer/imbp/components/ImbpBookings.vue"
import ImbpNoPermission from "@/views/customer/imbp/components/ImbpNoPermission.vue"
import ImbpRegisterInterestCompleted from "@/views/customer/imbp/components/ImbpRegisterInterestCompleted.vue"
import ImbpNewAppointmentType from "@/views/customer/imbp/components/ImbpNewAppointmentType.vue"
import ImbpNewIncludeSmartMeterUpgrade from "@/views/customer/imbp/components/ImbpNewIncludeSmartMeterUpgrade.vue"
import ImbpNewRaiseSiteworksTask from "@/views/customer/imbp/components/ImbpNewRaiseSiteworksTask.vue"
import ImbpNewRaiseMopMamDiscrepancyTask from "@/views/customer/imbp/components/ImbpNewRaiseMopMamDiscrepancyTask.vue"
import ImbpNewChooseAppointment from "@/views/customer/imbp/components/ImbpNewChooseAppointment.vue"
import ImbpRegisterInterest from "@/views/customer/imbp/components/ImbpRegisterInterest.vue"
import ImbpNewInstallationEssentials from "@/views/customer/imbp/components/ImbpNewInstallationEssentials.vue"
import ImbpNewMeterDetails from "@/views/customer/imbp/components/ImbpNewMeterDetails.vue"
import ImbpNewEngineerAccess from "@/views/customer/imbp/components/ImbpNewEngineerAccess.vue"
import CotNextResponsiblePartyInput from "@/views/customer/changeOfTenancy/components/CotNextResponsiblePartyInput.vue"
import DeceasedSummary from "@/views/customer/overview/deceased/components/DeceasedSummary.vue"
import DeceasedContactInput from "@/views/customer/overview/deceased/components/DeceasedContactInput.vue"
import SuggestedPaymentAmountSummary from "@/views/customer/financials/flows/components/SuggestedPaymentAmountSummary.vue"
import ChangePaymentCalculationRadio from "@/views/customer/financials/flows/components/ChangePaymentCalculationRadio.vue"
import ChooseFuelsRadio from "@/views/customer/financials/flows/components/ChooseFuelsRadio.vue"
import MeterpointsEstimationSelector from "@/views/customer/financials/flows/components/MeterpointsEstimationSelector.vue"
import UpdatePaymentSchedule from "@/views/customer/financials/flows/components/UpdatePaymentSchedule.vue"
import RecentReadsAlert from "@/views/customer/financials/flows/components/RecentReadsAlert.vue"
import RefundSummary from "@/views/customer/financials/flows/components/RefundSummary.vue"
import RefundInput from "@/views/customer/financials/flows/components/RefundInput.vue"
import RefundPaymentSummary from "@/views/customer/financials/flows/components/RefundPaymentSummary.vue"
import RefundAccountCheck from "@/views/customer/financials/flows/components/RefundAccountCheck.vue"
import RefundMeterPhoto from "@/views/customer/financials/flows/components/RefundMeterPhoto.vue"
import RefundPolicyCheck from "@/views/customer/financials/flows/components/RefundPolicyCheck.vue"
import BillLastReadingsAlert from "@/views/customer/financials/components/BillLastReadingsAlert.vue"
import PaymentIsLessThanSuggestedAlert from "@/views/customer/financials/flows/components/PaymentIsLessThanSuggestedAlert.vue"
import {
  displaySpaygElementTypeMap,
  inputSpaygElementTypeMap,
} from "../useCases/smartPayAsYouGo/types"
import SoNumberField from "@/components/formControls/SoNumberField.vue"
import ImbpNewAppointmentSummary from "@/views/customer/imbp/components/ImbpNewAppointmentSummary.vue"

// Add input or display elements below
export const inputElementTypeMap = {
  text: SoTextField,
  textarea: SoTextArea,
  numberinput: SoNumberField,
  datePicker: SoDatePicker,
  radioGroup: SoRadioGroup,
  checkbox: SoCheckbox,
  cotContactsInput: CotContactsInput,
  cotDirectDebitInput: CotDirectDebitInput,
  cotForwardAddressInput: CotForwardAddressInput,
  cotTariffInput: CotTariffInput,
  cotNextResponsiblePartyInput: CotNextResponsiblePartyInput,
  cotSubmitReadings: CotSubmitReadings,
  imbpJobType: ImbpJobType,
  imbpChooseAppointment: ImbpChooseAppointment,
  imbpExtraInformation: ImbpExtraInformation,
  imbpAppointmentSummary: ImbpAppointmentSummary,
  imbpNewAppointmentType: ImbpNewAppointmentType,
  imbpNewIncludeSmartMeterUpgrade: ImbpNewIncludeSmartMeterUpgrade,
  imbpNewChooseAppointment: ImbpNewChooseAppointment,
  imbpRegisterInterest: ImbpRegisterInterest,
  imbpNewInstallationEssentials: ImbpNewInstallationEssentials,
  imbpNewMeterDetails: ImbpNewMeterDetails,
  imbpNewEngineerAccess: ImbpNewEngineerAccess,
  refundInput: RefundInput,
  refundAccountCheck: RefundAccountCheck,
  refundMeterPhoto: RefundMeterPhoto,
  refundPolicyCheck: RefundPolicyCheck,
  ...inputSpaygElementTypeMap,
}

export const displayElementTypeMap = {
  alert: SoAlert,
  cotSummary: CotSummary,
  cotTariffInfo: CotTariffInfo,
  cotSupplyHistory: CotSupplyHistory,
  cotCompleted: CotCompleted,
  submitReadings: SubmitReadings,
  submitSmartReadings: FetchSmartReadWidgets,
  imbpBookings: ImbpBookings,
  imbpNoPermission: ImbpNoPermission,
  imbpRegisterInterestCompleted: ImbpRegisterInterestCompleted,
  imbpNewRaiseSiteworksTask: ImbpNewRaiseSiteworksTask,
  imbpNewRaiseMopMamDiscrepancyTask: ImbpNewRaiseMopMamDiscrepancyTask,
  imbpNewAppointmentSummary: ImbpNewAppointmentSummary,
  deceasedSummary: DeceasedSummary,
  deceasedContactInput: DeceasedContactInput,
  refundSummary: RefundSummary,
  refundPaymentSummary: RefundPaymentSummary,
  suggestedPaymentAmountSummary: SuggestedPaymentAmountSummary,
  changePaymentCalculationRadio: ChangePaymentCalculationRadio,
  chooseFuelsRadio: ChooseFuelsRadio,
  meterpointsEstimationSelector: MeterpointsEstimationSelector,
  updatePaymentSchedule: UpdatePaymentSchedule,
  recentReadsAlert: RecentReadsAlert,
  billLastReadingsAlert: BillLastReadingsAlert,
  paymentIsLessThanSuggestedAlert: PaymentIsLessThanSuggestedAlert,
  ...displaySpaygElementTypeMap,
}

export const elementTypeMap = {
  ...inputElementTypeMap,
  ...displayElementTypeMap,
}

export const serializedElementMap = mapKeysToValues(elementTypeMap)
